<template>
  <section class="tableWrap">

  </section>
</template>

<script>
// import DashBoardApi from '@/api/dashboard'
// import numeral from 'numeral'
export default {
  name: 'DashBoard',
  components: {},
  data: () => ({
    fav: true,
  }),
  methods: {},
  created() {
    const userMenus = JSON.parse(localStorage.getItem("userMenus"));
    if (!this.$store.state.user.userid)
      this.$router.push('/login');
    else {
      if(userMenus[0].href)
        this.$router.push(userMenus[0].href);
      else
        this.$router.push('/user');
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/style/layout/variables';

.dashWrap {
  display: flex;
}

.dashRow {
  display: flex;
  flex-direction: column;
  flex: 0 0 49%;

  &:first-child {
    margin-right: 2%;
  }
}

.tit {
  margin-top: 30px;
  margin-left: 5px;
  margin-bottom: 10px;
  font-size: 18px;
}

.dashBx {
  padding: 20px;
  border: 1px solid #e9e9e9;

  .state {
    padding-top: 37px;
    padding-bottom: 37px;
    cursor: pointer;
    color: #666;

    dt {
      display: flex;
      justify-content: center;
      align-items: baseline;
      margin-bottom: 20px;

      em {
        margin-right: 5px;
        font-size: 50px;
        font-weight: bold;
        color: #333;
      }
    }

    dd {
      font-weight: 500;
    }
  }

  .deposit {
    display: flex;
    padding: 0;

    li {
      display: flex;
      justify-content: space-between;
      flex: 0 0 25%;

      &:nth-child(3) {
        flex: 0 0 24%;
      }

      .depositTit {
        width: 100px;
        height: 30px;
        line-height: 30px;
        border: 1px solid #ccc;
        border-radius: 25px;
        background: #f6f6f6;
        font-size: 13px;
        font-weight: 600;
        color: #555;
        text-align: center;
      }

      .depositNum {
        display: flex;
        padding-top: 50px;
        padding-right: 30px;

        p {
          margin-right: 50px;

          em {
            font-size: 40px;
            font-weight: bold;
          }
        }
      }
    }
  }
}
</style>